import React from 'react'
import { graphql, Link } from 'gatsby'
import { GatsbyImage, getImage, getSrc } from 'gatsby-plugin-image'
import styled from 'styled-components'
import media from 'styled-media-query'
import PageBody from '@/components/organisms/PageBody'
import SEO from '@/components/SEO'
import GlobalCSS from '@/components/GlobalCss'
import Header from '@/components/organisms/Header'
import Wrapper from '@/components/atoms/Wrapper'
import AddFriendCV from '@/components/atoms/AddFriendCV'
import ShareButtons from '@/components/molecules/ShareButtons'
import Sponsors from '@/components/organisms/Sponsors'
import { COLOR, FONTSIZE, PADDING, SHADOW } from '@/shared/CssValue'
import Footer from '@/components/organisms/Footer'

const Container = styled.div``
const Layout = styled.div`
  margin-top: 90px;
  padding: 60px 0;
  ${media.lessThan('small')`
  margin-top: 70px;
  padding: 40px 0;
  `}
`
const Title = styled.h1`
  font-size: ${FONTSIZE.title};
  font-weight: 600;
  ${media.lessThan('medium')`
    font-size: ${FONTSIZE.sp_title}
  `}
`

const DateText = styled.p`
  font-size: ${FONTSIZE.regular};
  font-weight: 600;
  color: ${COLOR.baseColor};
  margin-top: ${PADDING.item};
  ${media.lessThan('medium')`
    font-size: ${FONTSIZE.sp_regular}
  `};
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`

const NavButton = styled(Link)`
  background-color: ${COLOR.baseColor};
  padding: 1em 3em;
  color: ${COLOR.white};
  text-decoration: none;
  border-radius: 6px;
  font-size: ${FONTSIZE.regular};
  font-weight: 600;
  box-shadow: ${SHADOW};
  transition-duration: 0.3s;
  ${media.lessThan('small')`
  font-size: ${FONTSIZE.small};
  `}
`

const BackButton = styled(NavButton)`
  background-color: ${COLOR.blue};
  margin-top: ${PADDING.item};
`

const ColumnPage = ({ data, pageContext }) => {
  const url = typeof window !== 'undefined' ? window.location.href : ''
  const { title, summary, thumbnail, body, date } =
    data.allContentfulColumn.edges[0].node
  const { prev, next } = pageContext
  const ogImage = getSrc(thumbnail)

  return (
    <Container>
      <SEO title={title} description={summary} image={ogImage} />
      <GlobalCSS />
      <Layout>
        <AddFriendCV />
        <Wrapper size="M">
          <Header />
          <Title>{title}</Title>
          <GatsbyImage image={getImage(thumbnail)} alt={title} />
          <DateText>{date}</DateText>
          <PageBody body={body} />
        </Wrapper>
      </Layout>
      <Wrapper>
        <ButtonWrapper>
          {next && <NavButton to={`/columns/${next}`}>前の記事</NavButton>}
          {prev && <NavButton to={`/columns/${prev}`}>次の記事</NavButton>}
        </ButtonWrapper>
        <ButtonWrapper>
          <BackButton to={`/columns/`}>コラム一覧へ</BackButton>
        </ButtonWrapper>
      </Wrapper>
      <Wrapper>
        <ShareButtons title={title} url={url} />
      </Wrapper>
      <Sponsors />
      <Footer />
    </Container>
  )
}

export default ColumnPage

export const query = graphql`
  query Columnquery($slug: String!) {
    allContentfulColumn(
      filter: { slug: { eq: $slug }, node_locale: { eq: "ja" } }
    ) {
      edges {
        node {
          title
          summary
          slug
          date(formatString: "YYYY年MM月DD日")
          thumbnail {
            gatsbyImageData(
              layout: FULL_WIDTH
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
          body {
            raw
            references {
              ... on ContentfulAsset {
                contentful_id
                __typename
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  }
`
